import { Button } from "@/components/ui/baseUi/button"
import { DiscountOfferForm } from "@/components/ui/forms/discountOfferForm"
import { cn } from "@/modules/lib/utils"
import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { useBoxOffer } from "@modules/boxOffer/hooks/useBoxOffer"
import {
  type CouponInputFormik,
  couponYupValidation,
  DurationType,
} from "@modules/boxSubscription/formik/boxSubscriptionFormik"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { LoggerType } from "@modules/utils/loggerUtils"
import { useFormik } from "formik"
import { ArrowLeft, Percent } from "lucide-react"
import { type Dispatch, type SetStateAction } from "react"
import { Text } from "@/components/ui/baseUi/text"

export type MemberSendOfferModalDiscountProps = {
  boxOfferId: string
  discountInput: CouponInputFormik
  setDiscountInput: Dispatch<SetStateAction<CouponInputFormik>>
  setIsDiscountVisible: Dispatch<SetStateAction<boolean>>
  className?: string
} & React.ComponentProps<"div">

export function MemberSendOfferModalDiscount({
  boxOfferId,
  discountInput,
  setDiscountInput,
  setIsDiscountVisible,
  className,
  ...props
}: MemberSendOfferModalDiscountProps) {
  const { data: boxOffer } = useBoxOffer(boxOfferId)

  const formik = useFormik<CouponInputFormik>({
    initialValues: { ...discountInput },
    validationSchema: couponYupValidation({ priceOffer: boxOffer?.price?.value || 0 }),
    onSubmit: () => {
      try {
        setDiscountInput(formik.values)
        setIsDiscountVisible(false)
      } catch (e: any) {
        console.error(LoggerType.UI + "discount in send box offer", e)
      }
    },
  })

  return (
    <div className={cn("mt-6 flex w-full grow flex-col gap-6", className)} {...props}>
      {/* TITLE */}
      <div className="flex items-center justify-center gap-2">
        <Percent color="currentColor" strokeWidth={1} size={13} className="text-textDefault-body" />
        <Text fontStyle="TS" className="text-center text-textDefault-body">
          {word("member.send.offer.modal.discount.title")}
        </Text>
      </div>
      {boxOffer && boxOffer.price && (
        <DiscountOfferForm
          formik={formik}
          isPending={false}
          price={boxOffer.price}
          isDisableMonthsInput={boxOffer.type === BoxOfferType.Subscription ? false : true}
        />
      )}

      {/* BUTTON */}
      <div className="mt-2 flex w-full flex-row items-end justify-center gap-2">
        <Button
          variant="outline"
          size="lg"
          className="grow"
          onClick={() => {
            setIsDiscountVisible(false)
            setDiscountInput({
              type: CouponType.PERCENT,
              value: 0,
              durationType: DurationType.UNLIMITED,
              months: null,
            })
          }}
        >
          <ArrowLeft strokeWidth={2} color="currentColor" size={15} />
          {discountInput.value !== 0 ? word("global.reset") : word("global.cancel")}
        </Button>

        <Button size="lg" variant="primary" className="grow" onClick={() => formik.handleSubmit()}>
          {word("global.check")}
        </Button>
      </div>
    </div>
  )
}
